import {  useAtom } from 'jotai';
import { LoginResult, LoginState, userService } from 'src/services/user/userService';
import { useCallback, useEffect, useState } from 'react';
import { LoginComponent } from 'src/login/LoginComponent';
import { useNavigate } from 'react-router-dom';
import { networkErrorAtom } from 'src/services/api/axiosService';
import { setDialogCloseCallback, useDialog } from 'src/components/Modalservice/Dialogservice';
import { AlertDialog, AlertOptions } from 'src/components/Modalservice/AlertDialog';
import { EmailVerifyDialog } from './EmailVerifyDialog';
import { CurrentUserDto } from 'src/services/user/types';
import { useI18n } from 'src/utils/lni18n';
import { loginService, openLoginAtom } from './LoginService';
import { useAlert } from 'src/components/Modalservice/UseAlert';

const LoginDialog = () => {

    const [networkError, setNetworkError] = useAtom(networkErrorAtom);
    const dialogPortal = useDialog();
    const [openDialog] = useAtom(openLoginAtom);
    const navigate = useNavigate();
    const { languageService: t } = useI18n();
    const alert = useAlert();


    useEffect(() => {
        if (!openDialog ) return;

        let prevUrl: string | undefined = undefined;
        if (networkError) {
            prevUrl = window.location.pathname;
        }

        navigate("/");
        showLoginDialog(prevUrl);

    }, [openDialog, networkError]);

 

    const showLoginDialog = (prevUrl?: string) => {

        dialogPortal({
            factory: (onSubmit, onCancel) => {

                return <LoginComponent onCancel={onCancel} onSubmit={onSubmit} />
            },
            size: "md"
        }).then( (res: LoginResult) => {
            if (res.state === LoginState.requireVerification) {
                // show next dialog after closing this
                setDialogCloseCallback( () => showEmailVerifyDialog(res.user!) )
            }
            else if (prevUrl) {
                navigate(prevUrl);
            }
        }).catch((e: Error) => {})
        .finally(() => {
            setNetworkError(null);
            loginService.setOpenDialog(false);
        });
    }

    const showEmailVerifyDialog = useCallback( async (user?: CurrentUserDto) => {

        const logOut = () => {
            userService().logoutUser(true);
            setNetworkError(null);
        }

        if (!user) {
            logOut();
            return;
        }

        try {
            const emailsent = await dialogPortal({
                factory: (onSubmit, onCancel) => {
                    return <EmailVerifyDialog languageService={t} user={user} onCancel={onCancel} onSubmit={onSubmit} />
                },
                size: "md"

            });

            if (emailsent) {
                const res = await userService().sendVerifyEmail(user, 1);
                if (res) {
                    await alert( "md", t.getText("dashboard.email.verification.header"),
                        <div className="preserve-white" >{res}</div>);
                }
            }
        } catch (e) {

        }
        finally {
            logOut();
        }

    }, []);

    return <></>
}


export default LoginDialog;